import { jsxs, jsx } from "react/jsx-runtime";
import { URL_CREATE_JOB, URL_PRODUCTS_AD_BUDGETS } from "@seek/adv-constants";
import { useTranslations } from "@vocab/react";
import { Text, Columns, Column, Box, Spread, Stack, Inline, ButtonLink, TextLink, TextLinkButton } from "braid-design-system";
import { HirerBalanceLayout, PriceTags } from "../../AdBudgetsUpsell/AdBudgetsUpsell.mjs";
import { formatExpiryDate, Remaining, ContractBalanceHeader } from "../../BalanceCarousel/BalanceCarouselWrapper.mjs";
import { translations } from "../../../../../HirerContractBalance/components/SeekContractBalanceDescription/.vocab/index.mjs";
import { translations as translations$1 } from "../../../../../HirerContractBalance/components/ContractBalance/.vocab/index.mjs";
import { icon } from "../../../HirerBalancePresentation.css.mjs";
const SeekContractBalanceDescription = ({ contractBalance, currentContract }) => {
  const { t } = useTranslations(translations);
  if (contractBalance.recommendUpSell) {
    return /* @__PURE__ */ jsxs(Text, { children: [
      t("you've used your..."),
      " ",
      formatExpiryDate(currentContract.expiry.expiryDate)
    ] });
  }
  return null;
};
const SeekContractBalanceView = ({
  buyAdBudgetClicked,
  canCreateJobs,
  contractBalance,
  createJobAdClicked,
  currentContract,
  showHeading,
  showCallout,
  urlResolver,
  warningType
}) => {
  const { t } = useTranslations(translations$1);
  const { dollarBased, recommendUpSell, totalValue } = contractBalance;
  return /* @__PURE__ */ jsx(HirerBalanceLayout, { children: /* @__PURE__ */ jsxs(
    Columns,
    {
      space: "medium",
      collapseBelow: "desktop",
      reverse: true,
      data: { testid: "SeekContractBalance" },
      children: [
        /* @__PURE__ */ jsx(Column, { width: "content", children: recommendUpSell ? /* @__PURE__ */ jsx(
          Box,
          {
            className: icon,
            display: "flex",
            padding: "large",
            borderRadius: "full",
            background: "surface",
            justifyContent: "center",
            alignItems: "center",
            children: /* @__PURE__ */ jsx(PriceTags, {})
          }
        ) : /* @__PURE__ */ jsx(
          Remaining,
          {
            totalValue,
            isDollarValue: dollarBased,
            warningType
          }
        ) }),
        /* @__PURE__ */ jsx(Column, { children: /* @__PURE__ */ jsxs(Spread, { direction: "vertical", space: "medium", children: [
          /* @__PURE__ */ jsxs(Stack, { space: "medium", children: [
            /* @__PURE__ */ jsx(
              ContractBalanceHeader,
              {
                contractBalance,
                currentContract,
                showHeading,
                warningType,
                showExpiryText: !recommendUpSell
              }
            ),
            recommendUpSell && /* @__PURE__ */ jsx(
              SeekContractBalanceDescription,
              {
                contractBalance,
                currentContract
              }
            )
          ] }),
          /* @__PURE__ */ jsxs(Inline, { space: "medium", alignY: "center", collapseBelow: "tablet", children: [
            canCreateJobs && /* @__PURE__ */ jsx(
              ButtonLink,
              {
                href: urlResolver({ path: URL_CREATE_JOB }),
                onClick: createJobAdClicked,
                children: t("Create a job ad")
              }
            ),
            recommendUpSell ? /* @__PURE__ */ jsx(
              TextLink,
              {
                href: urlResolver({ path: URL_PRODUCTS_AD_BUDGETS }),
                onClick: buyAdBudgetClicked,
                children: /* @__PURE__ */ jsx(
                  Text,
                  {
                    weight: "strong",
                    align: { mobile: "center", tablet: "left" },
                    children: t("Buy a new Ad Budget")
                  }
                )
              }
            ) : /* @__PURE__ */ jsx(
              Text,
              {
                weight: "strong",
                align: canCreateJobs ? { mobile: "center", tablet: "left" } : "left",
                children: /* @__PURE__ */ jsx(
                  TextLinkButton,
                  {
                    onClick: () => showCallout(contractBalance, warningType),
                    children: t("Balance details")
                  }
                )
              }
            )
          ] })
        ] }) })
      ]
    }
  ) });
};
export {
  SeekContractBalanceView
};
